import React from "react";
import { KurtMark } from "./KurtMark";
import { BookOpen, Power, Play, SlidersHorizontal, LogOut } from "lucide-react";

const TABS = [
  { id: "talk", label: "Talk to KURT" },
  { id: "today", label: "Today" },
  { id: "opportunities", label: "Opportunities" },
  { id: "approve", label: "Approve" },
  { id: "inbox", label: "Inbox" },
  { id: "covers", label: "Cover Chain" },
  { id: "traffic", label: "Traffic Engine" },
  { id: "seo", label: "SEO Engine" },
  { id: "sales", label: "Sales & Learning" },
];

export const Header = ({ tab, setTab, paused, onTogglePause, pendingCount, onOpenManual, onOpenControl, onLogout }) => (
  <header className="sticky top-0 z-50 h-16 px-4 md:px-6 flex items-center justify-between border-b border-white/10 bg-[#0B0F17]/80 backdrop-blur-xl">
    <button onClick={() => setTab("talk")} className="flex items-center gap-3 shrink-0">
      <KurtMark size={36} />
      <div className="leading-none text-left">
        <div className="kz-head font-extrabold text-lg tracking-tight">KURT<span className="text-emerald-400"> ZERO</span></div>
        <div className="flex items-center gap-1.5 mt-1">
          <span className={`w-1.5 h-1.5 rounded-full ${paused ? "bg-red-500 kz-blink" : "bg-emerald-400 kz-blink"}`} />
          <span className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold">{paused ? "Paused" : "Working"}</span>
        </div>
      </div>
    </button>

    <nav className="hidden lg:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
      {TABS.map((t) => (
        <button key={t.id} data-testid={`tab-${t.id}`} onClick={() => setTab(t.id)}
          className={`relative px-4 py-2 rounded-full text-sm font-medium transition-all hover:scale-[1.02] active:scale-[0.98] ${tab === t.id ? "text-slate-50 bg-white/[0.07]" : "text-slate-400 hover:text-slate-200"}`}>
          {t.label}
          {t.id === "approve" && pendingCount > 0 && (
            <span className="ml-1.5 inline-flex items-center justify-center text-[10px] font-bold px-1.5 h-4 min-w-4 rounded-full bg-amber-500 text-[#0B0F17]">{pendingCount}</span>
          )}
        </button>
      ))}
    </nav>

    <div className="flex items-center gap-1.5 shrink-0">
      <button data-testid="open-control-btn" onClick={onOpenControl} className="p-2 rounded-full text-slate-300 hover:text-slate-50 hover:bg-white/[0.06] transition-all" title="Control">
        <SlidersHorizontal size={18} />
      </button>
      <button data-testid="open-manual-btn" onClick={onOpenManual} className="p-2 rounded-full text-slate-300 hover:text-slate-50 hover:bg-white/[0.06] transition-all" title="Manual">
        <BookOpen size={18} />
      </button>
      {onLogout && (
        <button data-testid="logout-btn" onClick={onLogout} className="p-2 rounded-full text-slate-300 hover:text-red-400 hover:bg-white/[0.06] transition-all" title="Sign out">
          <LogOut size={18} />
        </button>
      )}
      <button data-testid="global-pause-btn" onClick={onTogglePause}
        className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition-all hover:scale-[1.02] active:scale-[0.98] ${paused ? "bg-emerald-500 text-[#04140d] hover:bg-emerald-400" : "bg-red-500/90 text-white hover:bg-red-500 kz-pulse-danger"}`}>
        {paused ? <Play size={16} /> : <Power size={16} />}
        <span className="hidden sm:inline">{paused ? "Resume" : "Pause all"}</span>
      </button>
    </div>
  </header>
);

export const MobileTabs = ({ tab, setTab, pendingCount }) => (
  <nav className="lg:hidden sticky top-16 z-40 flex overflow-x-auto gap-1 px-3 py-2 border-b border-white/10 bg-[#0B0F17]/90 backdrop-blur-xl">
    {TABS.map((t) => (
      <button key={t.id} data-testid={`tab-m-${t.id}`} onClick={() => setTab(t.id)}
        className={`whitespace-nowrap px-3.5 py-1.5 rounded-full text-xs font-medium transition-all ${tab === t.id ? "text-slate-50 bg-white/[0.08]" : "text-slate-400"}`}>
        {t.label}
        {t.id === "approve" && pendingCount > 0 && <span className="ml-1 text-[9px] font-bold px-1 rounded-full bg-amber-500 text-[#0B0F17]">{pendingCount}</span>}
      </button>
    ))}
  </nav>
);
